import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function PrerequisiteWarning() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1030">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1031">
        <div className="flex items-start gap-4 p-5 rounded-xl mb-12" style={{
        backgroundColor: '#fffbeb',
        border: '2px solid #c8a84b'
      }} data-id="element-1032">
          <AlertTriangleIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-1033" />
          <div data-id="element-1034">
            <p className="text-base font-bold mb-1" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1035">
              Course Pre-requisites:
            </p>
            <p className="text-base font-semibold" style={{
            color: '#d32f2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1036">
              Completion of basic handgun training or equivalent experience
              required. This is not a beginner firearms course.
            </p>
          </div>
        </div>
      </div>
    </div>;
}